export default __webpack_public_path__ + "static/media/login.3723f962.svg";